<app-modal-window [title]="'Создание паркомест'"
                  [visible]="true"
                  [width]="825"
                  [height]="638"
                  [scrollbar]="true"
                  (close)="dialogRef.close()">

  <div class="container">
    <div class="loading" *ngIf="loading; else loaded"></div>
    <ng-template #loaded>
      <div class="container-body">
        <div class="step step-1" *ngIf="currentStep === StepEnum.FirstStep">
          <span class="step-title">Тип паркинга</span>
          <div class="row">
            <div class="row-title">
              <span>Наземный</span>
              <span>Кол-во этажей </span>
            </div>
            <div class="row-input">
              <input type="text" class="input" [formControl]="parking1" [mask]="'separator'">
              <div class="error" *ngIf="parking1.hasError('min')">
                Значение не может быть меньше чем {{ parking1.getError('min')?.min }}
              </div>
              <div class="error" *ngIf="parking1.hasError('max')">
                Значение не может быть больше чем {{ parking1.getError('max')?.max }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="row-title">
              <span>Подземный</span>
              <span>Кол-во этажей </span>
            </div>
            <div class="row-input">
              <input type="text" class="input" [formControl]="parking2" [mask]="'separator'">
              <div class="error" *ngIf="parking2.hasError('min')">
                Значение не может быть меньше чем {{ parking2.getError('min')?.min }}
              </div>
              <div class="error" *ngIf="parking2.hasError('max')">
                Значение не может быть больше чем {{ parking2.getError('max')?.max }}
              </div>
            </div>
          </div>
        </div>

        <div class="step step-2" *ngIf="currentStep === StepEnum.SecondStep">
          <ng-container *ngIf="parkingList1.controls.length">
            <table>
              <tr><div class="step-2-title">Наземный</div></tr>
              <tr *ngIf="existParking1.length">
                <td></td>
                <td>Текущее количество помещений</td>
                <td>Количество новых помещений</td>
              </tr>
              <tr *ngFor="let _ of parkingList1.controls; let i = index">
                <td>
                  <label>Кол-во паркомест <b>на {{ existParking1[i]?.floorID }} этаже</b><span class="required">*</span> </label>
                </td>
                <td *ngIf="existParking1.length">
                  <div class="exist-place-count">{{existParking1[i]?.placeCount}}</div>
                </td>
                <td>
                  <input [formControl]="getParkingControl1(i)" class="input" [mask]="'separator'"/>
                </td>
              </tr>



              <ng-container *ngIf="parkingList2.controls.length">
                <tr>
                  <div class="step-2-title">Подземный</div>
                </tr>
                <tr *ngIf="existParking2.length">
                  <td></td>
                  <td>Текущее количество помещений</td>
                  <td>Количество новых помещений</td>
                </tr>
                <tr *ngFor="let _ of parkingList2.controls; let i = index">
                  <td>
                    <label>Кол-во паркомест <b>на P{{ existParking2[i]?.floorID }} </b><span class="required">*</span> </label>
                  </td>
                  <td *ngIf="existParking2.length">
                    <div class="exist-place-count">{{existParking2[i]?.placeCount}}</div>
                  </td>
                  <td>
                    <input [formControl]="getParkingControl2(i)" class="input" [mask]="'separator'"/>
                  </td>
                </tr>
              </ng-container>
            </table>
          </ng-container>


        </div>

      </div>
      <div class="container-footer">
        <ng-container *ngIf="currentStep === StepEnum.SecondStep">
          <button
            class="btn btn-apply prev-btn"
            (click)="prevStep()">
            <img src="./assets/svg-icons/arrow-white.svg" alt="">
          </button>
          <ng-container *ngIf="saveLoading; else loaded">
            <div class="loading"></div>
          </ng-container>
          <ng-template #loaded>
            <button
              class="btn btn-apply"
              [disabled]="formParkingList.invalid || !formParkingList.dirty"
              [ngClass]="{'disabled': formParkingList.invalid || !formParkingList.dirty}"
              (click)="save()">
              Сохранить
            </button>
          </ng-template>
        </ng-container>
        <button
          *ngIf="currentStep === StepEnum.FirstStep"
          class="btn btn-apply"
          [disabled]="isNextDisabled"
          [ngClass]="{'disabled': isNextDisabled}"
          (click)="nextStep()">
          Далее
        </button>
        <button class="btn btn-cancel" (click)="close()">Отмена</button>
      </div>
    </ng-template>
  </div>
</app-modal-window>
